<template>
  <UserDataProvider v-slot="{loaded}">
    <v-app-bar-nav-icon
      v-if="loaded"
      @click.stop="clickHandler"
    >
      <slot>
        <v-icon>{{ icon }}</v-icon>
      </slot>
    </v-app-bar-nav-icon>
  </UserDataProvider>
</template>

<script>
import { mdiMenu } from '@mdi/js'
import UserDataProvider from '@/components/frames/UserDataProvider'

export default {
  name: 'DrawerToggler',
  components: {
    UserDataProvider
  },
  props: {
    drawer: {
      type: String,
      default: 'main-navigation'
    },
    breakPoint: {
      type: String,
      default: null
    }
  },
  data: () => ({
    icon: mdiMenu
  }),
  computed: {
    show () {
      if (!this.$auth.isAuthenticated) {
        return false
      }
      if (!this.breakPoint) {
        return true
      }
      return this.$vuetify.breakpoint[this.breakPoint] || false
    }
  },
  methods: {
    clickHandler: function () {
      window.eventBus.$emit('toggle-drawer', this.drawer)
    }
  }
}
</script>
@/components/frames/UserDataProvider
